// src/contexts/SubscriptionContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext'; // If you have auth context

const SubscriptionContext = createContext();

export function SubscriptionProvider({ children }) {
  const [hasSubscription, setHasSubscription] = useState(true); // Default to true for development
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth(); // If you have auth context

  const checkUserSubscription = async (userId) => {
    // Temporarily disable subscription check
    return true;

    /* Original code commented out
    try {
      if (process.env.NODE_ENV === 'development') {
        return true;
      }

      const response = await fetch(`/api/subscriptions/${userId}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data.hasActiveSubscription;
    } catch (error) {
      console.error('Error checking subscription:', error);
      if (process.env.NODE_ENV === 'development') {
        return true;
      }
      throw error;
    }
    */
  };

  useEffect(() => {
    const fetchSubscription = async () => {
      if (process.env.NODE_ENV === 'development') {
        setHasSubscription(true);
        setIsLoading(false);
        return;
      }

      if (user?.uid) {
        try {
          const status = await checkUserSubscription(user.uid);
          setHasSubscription(status);
        } catch (error) {
          console.error('Failed to fetch subscription:', error);
          setError(error);
          // For development, set to true despite errors
          if (process.env.NODE_ENV === 'development') {
            setHasSubscription(true);
          }
        }
      }
      setIsLoading(false);
    };

    fetchSubscription();
  }, [user]);

  return (
    <SubscriptionContext.Provider value={{ hasSubscription, isLoading, error }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
}